export default __webpack_public_path__ + "static/media/DSImage.f8ba84c7.png";